if (!customElements.get('sok-range')) {
  class SokRange extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.cards = [...this.grid.children];
      this.filters = [...this.querySelectorAll('[data-tag]')].filter((el) => el.matches('button'));
      this.filters.forEach((button) => button.addEventListener('click', () => this.select(button)));
    }

    select(button) {
      if (button.classList.contains('is-active')) return;
      this.filters.forEach((b) => {
        b.classList.toggle('is-active', b === button);
        b.setAttribute('aria-selected', String(b === button));
      });
      const tag = button.dataset.tag;
      clearTimeout(this.timer);
      this.grid.classList.add('is-fading');
      this.timer = setTimeout(() => {
        this.cards.forEach((card) => {
          card.hidden = Boolean(tag) && !card.dataset.tags.split(' ').includes(tag);
        });
        this.grid.classList.toggle('is-all', !tag);
        this.grid.classList.remove('is-fading');
      }, 220);
    }
  }

  customElements.define('sok-range', SokRange);
}
